import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useState } from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import styles from "./legal-agreement.module.css";

function createMarkup(value) {
    return { __html: value };
}

function LegalAgreement({
    captureType,
    className,
    cookiePolicyLink,
    requiresOptIn,
    handleLegalChange,
    privacyPolicyLink,
    shortVersion,
    submitText,
    termsAndConditionsLink,
}) {
    const [privacyPolicy, setPrivacyPolicy] = useState(false);
    const [marketingEmails, setMarketingEmails] = useState(false);
    const privacyPolicyLinkProps = `href=${privacyPolicyLink} target="_blank"`;
    const termsAndConditionsLinkProps = `href=${termsAndConditionsLink} target="_blank"`;
    const cookiePolicyLinkProps = `href=${cookiePolicyLink} target="_blank"`;
    if (requiresOptIn) {
        if (shortVersion) {
            handleLegalChange(true, marketingEmails);
            return (
                <div className={styles.legalAgreement}>
                    <div className={styles.checkboxFieldset}>
                        <input
                            className={styles.checkbox}
                            type="checkbox"
                            name="marketing_emails"
                            checked={marketingEmails}
                            id="marketing-emails"
                            onChange={(e) => {
                                const action = e.target.checked ? "tick_box" : "untick_box";
                                analytics.event(captureType, action, "tickbox_marketing");
                                setMarketingEmails(e.target.checked);
                                handleLegalChange(true, e.target.checked);
                            }}
                        />
                        <label
                            className={styles.marketingLabel}
                            htmlFor="marketing-emails"
                            dangerouslySetInnerHTML={createMarkup(
                                // "I would like to hear about products, services, and sales, including
                                // personalized email alerts from Lyst. You can unsubscribe at any time."
                                gettext("account.register.legal_agreement.sign_up_checkbox_label")
                            )}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div className={clsx(className, styles.legalAgreement)}>
                    <div className={styles.checkboxFieldset}>
                        <input
                            className={styles.checkbox}
                            type="checkbox"
                            name="marketing_emails"
                            checked={marketingEmails}
                            id="marketing-emails"
                            onChange={(e) => {
                                const action = e.target.checked ? "tick_box" : "untick_box";
                                analytics.event(captureType, action, "tickbox_marketing");
                                setMarketingEmails(e.target.checked);
                                handleLegalChange(privacyPolicy, e.target.checked);
                            }}
                        />
                        <label
                            className={styles.marketingLabel}
                            htmlFor="marketing-emails"
                            dangerouslySetInnerHTML={createMarkup(
                                // "I would like to hear about products, services, and sales, including
                                // personalized email alerts from Lyst. You can unsubscribe at any time."
                                gettext("account.register.legal_agreement.sign_up_checkbox_label")
                            )}
                        />
                    </div>
                    <div className={styles.checkboxFieldset}>
                        <input
                            className={styles.checkbox}
                            type="checkbox"
                            name="privacy_policy"
                            id="privacy-policy"
                            checked={privacyPolicy}
                            onChange={(e) => {
                                const action = e.target.checked ? "tick_box" : "untick_box";
                                analytics.event(captureType, action, "tickbox_privacy_policy");
                                setPrivacyPolicy(e.target.checked);
                                handleLegalChange(e.target.checked, marketingEmails);
                            }}
                        />
                        <label
                            htmlFor="privacy-policy"
                            dangerouslySetInnerHTML={createMarkup(
                                gettext(
                                    "account.register.legal_agreement.privacy_policy_checkbox_label",
                                    {
                                        privacy_policy_link_props: privacyPolicyLinkProps,
                                    }
                                )
                            )}
                        />
                    </div>
                </div>
            );
        }
    } else {
        handleLegalChange(true, true);
        const country = environment.get("country");

        let text = gettext("account.register.legal_agreement.us_text", {
            submit_btn_text: submitText,
            terms_and_conditions_link_props: termsAndConditionsLinkProps,
            privacy_policy_link_props: privacyPolicyLinkProps,
            cookie_policy_link_props: cookiePolicyLinkProps,
        });

        if (country == "US") {
            // "By creating an account, you consent to Lyst’s Terms & Conditions and you agree to receive email updates from Lyst. To learn more about how Lyst uses and protects your personal data, please read Lyst’s Privacy Policy."
            text = gettext("account.register.legal_agreement.sign_up_opt_in_terms_us_version", {
                terms_and_conditions_link_props: termsAndConditionsLinkProps,
                privacy_policy_link_props: privacyPolicyLinkProps,
            });
        }

        return (
            <div
                className={clsx(className, styles.legalAgreementSmall)}
                dangerouslySetInnerHTML={createMarkup(text)}
            />
        );
    }
}

export default LegalAgreement;

LegalAgreement.propTypes = {
    captureType: PropTypes.string,
    className: PropTypes.string,
    cookiePolicyLink: PropTypes.string,
    requiresOptIn: PropTypes.bool,
    handleLegalChange: PropTypes.func.isRequired,
    privacyPolicyLink: PropTypes.string.isRequired,
    shortVersion: PropTypes.bool,
    submitText: PropTypes.string,
    termsAndConditionsLink: PropTypes.string,
};
